import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { ADDRESS_RULE } from '@/common/utils/rules/address.rules';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import ConfirmDriverModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/ConfirmDriverModal';
import { GetCulpritDriverInfoFormType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQuery.type';
import { CulpritContactInfo } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritContactInfo/patchCulpritContactInfoQuery.type';
import { usePatchCulpritContactInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritContactInfo/patchCulpritContactInfoQueryOptions';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const ContactCulpritInformation = () => {
  const { id } = useParams();
  const [openModal, setOpenModal] = React.useState(false);
  const navigate = useNavigate();

  const methods = useFormContext<GetCulpritDriverInfoFormType>();
  const isOwnerDriver = methods?.watch('personal_information.is_owner_driver');
  const { mutate: patchCulpritDriverInfo, isPending: loading } =
    usePatchCulpritContactInfoQueryOptions();
  const onSubmit = (formData: GetCulpritDriverInfoFormType) => {
    const contactInfo: CulpritContactInfo = {
      phone_number:
        formData.contact_information?.phone_number === ''
          ? null
          : formData.contact_information?.phone_number,
      city_code:
        formData.contact_information?.city_code === ''
          ? null
          : formData.contact_information?.city_code,
      phone:
        formData.contact_information?.phone === ''
          ? null
          : formData.contact_information?.phone,
      postal_code:
        formData.contact_information?.postal_code === ''
          ? null
          : formData.contact_information?.postal_code,
      address:
        formData.contact_information?.address === ''
          ? null
          : formData.contact_information?.address,
    };
    patchCulpritDriverInfo(
      { data: contactInfo, id: +id! },
      {
        onSuccess: () => {
          isOwnerDriver ? navigate(-1) : setOpenModal(true);
        },
      },
    );
  };

  const previousStep = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
        id: +id!,
      }).DRIVER_OWNER_INFORMATION.certificate,
      { replace: true },
    );
  };
  return (
    <Flex direction="column" gap={8}>
      <ConfirmDriverModal
        open={openModal}
        setOpenModal={setOpenModal}
        cancelNavigate={() => navigate(-1)}
        navigateTo={() =>
          navigate(
            ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_INFORMATION({
              id: +id!,
            }).DRIVER_OWNER_INFORMATION.owner,
            { replace: true },
          )
        }
      />
      <Box>
        <MobileInput
          name="contact_information.phone_number"
          label="تلفن همراه "
          rules={{ required: requiredText, ...MOBILE_NUMBER_RULE }}
        />
      </Box>

      <Box display="flex" flexDirection="row" gap="10px">
        <Box flexBasis={'80%'}>
          <TextInput
            name="contact_information.phone"
            label="تلفن ثابت"
            key={'phone'}
            rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
            max={8}
            direction="ltr"
            placeholder="XX-XX-XX-XX"
            noCharInput={true}
          />
        </Box>
        <Box flexBasis={'30%'}>
          <TextInput
            name="contact_information.city_code"
            key={'city_code'}
            direction="ltr"
            placeholder="کد شهر"
            rules={{
              minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
              required: requiredText,
            }}
            max={3}
            noCharInput={true}
          />
        </Box>
      </Box>
      <Box>
        <TextInput
          label="کدپستی"
          optionalLabel
          name="contact_information.postal_code"
          placeholder="کدپستی را وارد کنید"
          rules={{ ...POSTAL_CODE_RULE, required: false }}
          defaultValue=""
          noCharInput
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="آدرس"
          optionalLabel
          name="contact_information.address"
          placeholder="آدرس را وارد کنید"
          rules={{ required: false, ...ADDRESS_RULE }}
          defaultValue=""
        />
      </Box>
      <Flex w="100%" gap={16} mb="1rem">
        <Button fullWidth variant="outlined" onClick={previousStep}>
          مرحله قبل
        </Button>{' '}
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت
        </LoadingButton>
      </Flex>
    </Flex>
  );
};

export default ContactCulpritInformation;
